import { render } from "./RemainingVacationManage.vue?vue&type=template&id=fc70ceb8"
import script from "./RemainingVacationManage.vue?vue&type=script&lang=js"
export * from "./RemainingVacationManage.vue?vue&type=script&lang=js"

import "./RemainingVacationManage.vue?vue&type=style&index=0&id=fc70ceb8&lang=less"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__